const Main = () => {

   

    return ( 
        <div className='Main-Section'>
            <span className='Name'>Hi, i'm Nibras 👋🏾</span><br></br>
        <div className='role'>
            <span>Front End Developer | </span>
            <span>UI/UX Designer</span>
        </div>
            <div className='btn-container'>
                <button className='hire-me-btn'>Hire me</button>
                <button className='resume-btn'>View Resume</button>
            </div>
        </div>
     );
}
 
export default Main;